export default (url: string) => {
  switch (url) {
    case 'kindergarten':
      return 'Nursery';
      break;
    case 'unterstufe':
      return 'JuniorSchool';
      break;
    case 'mittelstufe':
      return 'MiddleSchool';
      break;
    case 'tagesbetreuung':
      return 'DayCare';
      break;
    default:
      return 'Nursery';
  }
};
